import { computed } from 'vue'
import { globalUtils } from '@gat-ship/utils'
import type { ClientRef } from '@gat-ship/types'
import { searchClientsRequest } from '../model/client-api-calls'

/**
 * Debounced, server-side client search backing the `ClientSearchPicker`.
 *
 * Like `useVesselSearchDataSource` (and unlike the list-and-filter ref-data
 * datasources), every keystroke hits `ref-data/stakeholders/clients/search`:
 * the stakeholder master is too large to load eagerly. The endpoint returns
 * only active clients. Mirrors the `usePrincipalSearch` pattern it replaces — a
 * debounced input with in-flight abort and a race-safe results ref.
 */
export function useClientSearchDataSource() {
  const { searchInputValue, searchResults, isSearching, clearAll } =
    globalUtils.composables.useDebouncedSearchInput<ClientRef>({
      apiCall: (inputValue, signal) =>
        searchClientsRequest(inputValue ?? '', { signal })
    })

  const clients = computed<ClientRef[]>(() => searchResults.value)

  return { searchInputValue, clients, isSearching, clearAll }
}
